export type ScreenerImportRowResult = {
  row: number;
  email: string;
  status: "Success" | "Failed" | string;
  error: string;
  participantId?: string;
  participantAction?: "created" | "existing" | string;
};

export type ScreenerImportChunk = {
  chunkIndex?: number;
  rowResults?: ScreenerImportRowResult[];
  row_results?: ScreenerImportRowResult[];
};

export type ScreenerImportJobWithChunks = {
  id?: string;
  status?: string;
  failedCount?: number;
  chunks?: ScreenerImportChunk[];
};

export function extractFailedRows(
  chunks?: ScreenerImportChunk[] | null,
): ScreenerImportRowResult[] {
  if (!chunks?.length) return [];

  const merged = chunks.flatMap((chunk) => {
    const rows = chunk.rowResults ?? chunk.row_results ?? [];
    return Array.isArray(rows) ? rows : [];
  });

  return merged
    .filter((row) => String(row.status).toLowerCase() === "failed")
    .sort((a, b) => Number(a.row) - Number(b.row));
}
